// This file is auto-generated. Do not edit directly.

export const themeStyle = {
  borderRadius0: 'var(--border-radius-0)',
  borderRadius2: 'var(--border-radius-2)',
  borderRadius4: 'var(--border-radius-4)',
  borderRadius6: 'var(--border-radius-6)',
  borderRadius7: 'var(--border-radius-7)',
  borderRadius8: 'var(--border-radius-8)',
  borderRadius10: 'var(--border-radius-10)',
  borderRadius12: 'var(--border-radius-12)',
  borderRadiusFull: 'var(--border-radius-full)',
  legacyColorsInkMain: 'var(--legacy-colors-ink-main)',
  legacyColorsInkMedium: 'var(--legacy-colors-ink-medium)',
  legacyColorsBackgroundAlt: 'var(--legacy-colors-background-alt)',
  legacyColorsInkSuperLight: 'var(--legacy-colors-ink-super-light)',
  legacyColorsBrandLight: 'var(--legacy-colors-brand-light)',
  legacyColorsBrandMain: 'var(--legacy-colors-brand-main)',
  legacyColorsInkLight: 'var(--legacy-colors-ink-light)',
  legacyColorsHighlight: 'var(--legacy-colors-highlight)',
  legacyColorsInkMediumLight: 'var(--legacy-colors-ink-medium-light)',
  legacyColorsViolet: 'var(--legacy-colors-violet)',
  legacyColorsRedMain: 'var(--legacy-colors-red-main)',
  legacyColorsRedMedium: 'var(--legacy-colors-red-medium)',
  legacyColorsRedLight: 'var(--legacy-colors-red-light)',
  legacyColorsBlueMain: 'var(--legacy-colors-blue-main)',
  legacyColorsBlueMedium: 'var(--legacy-colors-blue-medium)',
  legacyColorsTransparentMain15: 'var(--legacy-colors-transparent-main-15)',
  legacyColorsTransparentMain10: 'var(--legacy-colors-transparent-main-10)',
  legacyColorsGreenMain: 'var(--legacy-colors-green-main)',
  legacyColorsBlueLight: 'var(--legacy-colors-blue-light)',
  legacyColorsTransparentMain5: 'var(--legacy-colors-transparent-main-5)',
  legacyColorsRedSuperLight: 'var(--legacy-colors-red-super-light)',
  colorBgFill: 'var(--color-bg-fill)',
  colorBgFillSecondary: 'var(--color-bg-fill-secondary)',
  colorBgFillBrand: 'var(--color-bg-fill-brand)',
  colorBgFillSuccess: 'var(--color-bg-fill-success)',
  colorBgFillCritical: 'var(--color-bg-fill-critical)',
  colorBgFillBrandHover: 'var(--color-bg-fill-brand-hover)',
  colorBgFillHover: 'var(--color-bg-fill-hover)',
  colorBgFillActive: 'var(--color-bg-fill-active)',
  colorBgFillSelector: 'var(--color-bg-fill-selector)',
  colorBgFillSelectorActive: 'var(--color-bg-fill-selector-active)',
  colorBgFillHighlight: 'var(--color-bg-fill-highlight)',
  colorBgFillBrandTransparent: 'var(--color-bg-fill-brand-transparent)',
  colorBgFillDisabled: 'var(--color-bg-fill-disabled)',
  colorBgSurface: 'var(--color-bg-surface)',
  colorBgSurfaceSecondary: 'var(--color-bg-surface-secondary)',
  colorBgSurfaceCritical: 'var(--color-bg-surface-critical)',
  colorBgSurfaceHighlight: 'var(--color-bg-surface-highlight)',
  colorBgSurfacePlayful: 'var(--color-bg-surface-playful)',
  colorBgFillInfo: 'var(--color-bg-fill-info)',
  colorBgFillTertiary: 'var(--color-bg-fill-tertiary)',
  colorBgFillSelectorHover: 'var(--color-bg-fill-selector-hover)',
  colorBgFillTransparent: 'var(--color-bg-fill-transparent)',
  colorBgFillTransparentHover: 'var(--color-bg-fill-transparent-hover)',
  colorBgFillInfoSecondary: 'var(--color-bg-fill-info-secondary)',
  colorBgFillBrandActive: 'var(--color-bg-fill-brand-active)',
  colorBgFillCriticalHover: 'var(--color-bg-fill-critical-hover)',
  colorBgFillCriticalActive: 'var(--color-bg-fill-critical-active)',
  colorBgFillSecondaryHover: 'var(--color-bg-fill-secondary-hover)',
  colorBgFillSecondaryActive: 'var(--color-bg-fill-secondary-active)',
  colorBgFillThemeAgnosticWhite: 'var(--color-bg-fill-theme-agnostic-white)',
  colorBgSurfaceTransparent: 'var(--color-bg-surface-transparent)',
  colorBgFillThemeAgnosticBlack: 'var(--color-bg-fill-theme-agnostic-black)',
  colorBgFillThemeAgnosticGray: 'var(--color-bg-fill-theme-agnostic-gray)',
  colorBgSurfaceThemeAgnosticWhite:
    'var(--color-bg-surface-theme-agnostic-white)',
  colorBgSurfaceHighlightSecondary:
    'var(--color-bg-surface-highlight-secondary)',
  colorBgSurfaceHighlightTertiary: 'var(--color-bg-surface-highlight-tertiary)',
  colorTextBrandOnBg: 'var(--color-text-brand-on-bg)',
  colorIcon: 'var(--color-icon)',
  colorText: 'var(--color-text)',
  colorTextSecondary: 'var(--color-text-secondary)',
  colorIconSecondary: 'var(--color-icon-secondary)',
  colorBorder: 'var(--color-border)',
  colorBorderFocused: 'var(--color-border-focused)',
  colorTextDisabled: 'var(--color-text-disabled)',
  colorTextCritical: 'var(--color-text-critical)',
  colorBorderCritical: 'var(--color-border-critical)',
  colorIconActive: 'var(--color-icon-active)',
  colorTextLink: 'var(--color-text-link)',
  colorAvatarBlue: 'var(--color-avatar-blue)',
  colorAvatarBlueSecondary: 'var(--color-avatar-blue-secondary)',
  colorTextInfo: 'var(--color-text-info)',
  colorIconDisabled: 'var(--color-icon-disabled)',
  colorBorderBrand: 'var(--color-border-brand)',
  colorBorderThemeAgnosticViolet: 'var(--color-border-theme-agnostic-violet)',
  colorTextTertiary: 'var(--color-text-tertiary)',
  colorBorderTransparent: 'var(--color-border-transparent)',
  colorBorderThemeAgnosticWhite: 'var(--color-border-theme-agnostic-white)',
  colorBorderSelector: 'var(--color-border-selector)',
  colorBorderSelectorHover: 'var(--color-border-selector-hover)',
  colorIconBrandOnBg: 'var(--color-icon-brand-on-bg)',
  colorIconCritical: 'var(--color-icon-critical)',
  colorBorderThemeAgnosticGray: 'var(--color-border-theme-agnostic-gray)',
  colorIconTertiary: 'var(--color-icon-tertiary)',
  colorTextSecondaryDisabled: 'var(--color-text-secondary-disabled)',
  colorTextThemeAgnosticWhite: 'var(--color-text-theme-agnostic-white)',
  colorTextThemeAgnosticBlack: 'var(--color-text-theme-agnostic-black)',
  colorIconThemeAgnosticWhite: 'var(--color-icon-theme-agnostic-white)',
  colorBorderSelectorInner: 'var(--color-border-selector-inner)',
  spacing0: 'var(--spacing-0)',
  spacing2: 'var(--spacing-2)',
  spacing4: 'var(--spacing-4)',
  spacing6: 'var(--spacing-6)',
  spacing8: 'var(--spacing-8)',
  spacing10: 'var(--spacing-10)',
  spacing12: 'var(--spacing-12)',
  spacing16: 'var(--spacing-16)',
  spacing20: 'var(--spacing-20)',
  spacing24: 'var(--spacing-24)',
  spacing32: 'var(--spacing-32)',
  spacing36: 'var(--spacing-36)',
  spacing40: 'var(--spacing-40)',
  spacing48: 'var(--spacing-48)',
  motionDuration300: 'var(--motion-duration-300)',
  boxShadowDefault: 'var(--box-shadow-default)',
};
